import { SimpleEventEmitter } from "@sail/utils";
import patchBrowserStorage from "../browserStorage/patchBrowserStorage";
export default function createSessionStorageEventListener(reports) {
    const simpleEventEmitter = new SimpleEventEmitter();
    patchBrowserStorage('sessionStorage', simpleEventEmitter.notify.bind(simpleEventEmitter), reports);
    return simpleEventEmitter;
}

//# sourceMappingURL=createSessionStorageEventListener.js.map